export default __webpack_public_path__ + "../staticImages/tesdorpf_logo.svg";